import config from '../../config';
import { request, requestWithGet } from '../../utils/request';

export function refreshtToken(refreshtToken) {
  return request('user/refresh-token', { refresh_token: refreshtToken });
}

export function login(params = {}) {
  params = { ...params, login: false };
  return new Promise((resolve, reject) => {
    return request('/v1/user/otherLogin', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 3m登录
 */
export const usernameLogin = params => {
  return new Promise((resolve, reject) => {
    request(`tailored/login/password`, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
};

/**
 * 发送验证码
 * @param {number} tel 手机号
 */
export function sendCode(tel) {
  return request('/v1/sms/verify', { mobile: tel });
}

/**
 * 获取手机号
 */
export function query(params) {
  return new Promise((resolve, reject) => {
    request('/clinet/user/query', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
/**
 * 发送修改密码的验证码
 */
export function pwdVerify(params) {
  return new Promise((resolve, reject) => {
    request('/v1/sms/query/mobile/verify', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 3m获取手机号
export function tailoredUserMobile(params) {
  return new Promise((resolve, reject) => {
    request('/tailored/user/mobile', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 修改密码
 */
export function change_pwd(params) {
  return new Promise((resolve, reject) => {
    request('/clinet/change/password', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 修改3m密码
 */
export const change_3m_pwd = (params = {}) => {
  return new Promise((resolve, reject) => {
    request('tailored/login/password/change', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
};

/**
 * 获取全局配置
 * @param {number} channelId
 * @param {number} cityId
 * @param {number} customId
 */
export function getSiteConfig(channelId, cityId, customId) {
  return new Promise((resolve, reject) => {
    request('/v1/config/index', {
      channel_id: channelId,
      city_id: cityId,
      custom_id: customId
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 首次登录弹窗
export function firstLogin(params) {
  return new Promise((resolve, reject) => {
    request('/clinet/first/login', params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 高德 Web 服务 API（restapi.amap.com）不允许浏览器直连（CORS），所以：
//   1) 先走同源 /amap（本地由 vue.config.js 代理，线上由 nginx 转发到 restapi.amap.com）
//   2) 同源不通（例如线上还没配 nginx）再退回原来的绝对地址，最终失败交给调用方兜底
// 注意地址必须带完整 origin：axios 的 baseURL 只对「非绝对地址」生效，
// 写 '/amap/...' 会被拼成 api 域名，走不到同源代理
const AMAP_ORIGIN_URL = path => `${window.location.origin}/amap${path}`;
// 回退地址固定用 https：页面是 http 时 //restapi.amap.com 会走 http，
// 高德会 301 到 https，重定向响应没有 CORS 头，浏览器同样会拦
const AMAP_DIRECT_URL = path => `https://restapi.amap.com${path}`;

const amapGet = (path, params = {}) => {
  const reqParams = { ...params, key: params.key || config.amapWebServeKey };
  return requestWithGet(AMAP_ORIGIN_URL(path), reqParams).catch(() =>
    requestWithGet(AMAP_DIRECT_URL(path), { ...reqParams })
  );
};

export const regeo = (params = {}) => {
  return new Promise((resolve, reject) => {
    amapGet('/v3/geocode/regeo', params)
      .then(res => {
        if (res && res.regeocode) resolve(res.regeocode);
      })
      .catch(err => reject(err));
  });
};

export const geo = (params = {}) => {
  return new Promise((resolve, reject) => {
    amapGet('/v3/geocode/geo', params)
      .then(res => {
        if (res && res.geocodes && res.geocodes.length)
          resolve(res.geocodes[0]);
      })
      .catch(err => reject(err));
  });
};

export const getAllCity = () => {
  return new Promise((resolve, reject) => {
    request('/v1/region/goods-city-filter-list')
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
};

export const getRegionList = parentId => {
  return new Promise((resolve, reject) => {
    request('/v1/region/list', {
      parent_id: parentId
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
};

// 查询待领取卡券信息
export const card_receive_list = params => {
  return new Promise((resolve, reject) => {
    request(`/v1/card/receive/list`, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
};
